<!--
- 动脉橙首页
- 创建人: lzp
- 创建时间: 2019-09-20
- 修改人： wang.y
- 修改时间： 2019-09-25
-->
<template lang="html">
  <div class="account-container">
    <div class="left">
      <div class="left-base">
        <img :src="user.wx_avatarurl" v-if="user.wx_avatarurl" />
        <i class="iconfont default" v-else>&#xe65b;</i>
        <p class="nick-name">{{user.name ? user.name:user.wx_nickname}}</p>
        <p class="open-vip" @click="goOpenVip" v-if="user.db_vip != '1' && user.vip != '1'"><img :src="$store.state.static_img_url + 'pic/vip_icon.png'" class="vip-icon">开通VIP </p>
        <Poptip trigger="click" placement="bottom" width="160" class="pop" v-else>
          <p class="open-vip" ><img :src="$store.state.static_img_url + 'pic/vip_icon.png'" class="vip-icon">VIP </p>
          <div slot="content">
            <p>到期时间{{user.vip_end_time | timeTrans}}</p>
            <div class="xufei" @click="goOpenVip">
              立即续费
            </div>
          </div>
        </Poptip>
      </div>
      <!-- <div class="left-item">
        账户设置
      </div> -->
    </div>
    <div class="right" ref='right' :style="{'min-height':height+'px'}">
      <div class="right-setting">
        <p>账户设置</p>
        <!-- 展示状态 -->
        <div class="tip" v-if="!base_edit && (!(user.xuser_type_id && user.xuser_type_id != '') || !(group_subscribe && group_subscribe.length > 0))"><i class="iconfont">&#xe654;</i>完善更多信息，获取更精准的个性化服务</div>
        <div class="show-div" v-if="!base_edit">
            <p><span class="must">姓名</span><span>{{user.name | empty('暂无')}}</span></p>
            <p><span class="must">公司</span><span>{{user.compName | empty('暂无')}}</span></p>
            <p><span class="must">职位</span><span>{{user.title | empty('暂无')}}</span></p>
            <p><span class="must">手机</span><span>{{user.mobile | empty('暂无')}}</span></p>
            <p><span>邮箱</span><span>{{user.email | empty('暂无')}}</span></p>
            <p v-if="user.xuser_type_id && user.xuser_type_id != ''"><span>身份</span><span>{{user.xuser_type_id | dealName(xuser_type)}}</span></p>
            <!-- <div class="d-tag" v-if="group_subscribe && group_subscribe.length > 0">
                <p>关注领域</p>
                <div>
                    <span class="span_tag" v-for="item in group_subscribe" :key="item.id">{{item.sub_type_id | dealName(entity_ntag)}}</span>
                </div>
            </div> -->
            <div class="edit-button" @click="goEdit">编辑</div>
        </div>
        <!-- 编辑状态 -->
        <div class="editing-div" v-if="base_edit">
          <Form :model="form_data" label-position="left" :label-width="50" :rules="rules" ref="base_form">
            <FormItem label="姓名" prop="name">
              <Input v-model="form_data.name" autocomplete="off" placeholder="请输入您的姓名"></Input>
            </FormItem>
            <FormItem label="公司"  prop="comp_name">
              <Input v-model="form_data.comp_name" autocomplete="off" placeholder="请输入您的公司"></Input>
            </FormItem>
            <FormItem label="职位"  prop="title">
              <Input v-model="form_data.title" autocomplete="off" placeholder="请输入您的职位"></Input>
            </FormItem>
            <FormItem label="手机" class="phone">
              <Input disabled :value="user.mobile" autocomplete="off" placeholder="请输入您的手机"></Input>
            </FormItem>
            <FormItem label="邮箱"  prop="email">
              <Input v-model="form_data.email" autocomplete="off" placeholder="请输入您的邮箱"></Input>
            </FormItem>
          </Form>
          <p class="more-title">
              <span>个性化服务</span>
          </p>
          <div class="identity">
              <p>身份选择</p>
              <div>
                  <Select v-model="identity_params.xuser_type_id" class="identity-sel">
                      <Option v-for="item in xuser_type" :value="item.id" :key="item.id">{{item.name}}</Option>
                  </Select>
              </div>
          </div>
          <!-- <div class="tag">
              <p>关注领域</p>
              <div>
                  <div class="tags-list">
                      <a class="show-all" @click="is_show_tag = !is_show_tag">
                        <template v-if="is_show_tag">收起<i class="iconfont">&#xe63b;</i></template>
                        <template v-else>展开<i class="iconfont">&#xe648;</i></template>
                      </a>
                      <div class="span_tag" v-for="item,index in recommend_tag_map" v-show="index < 7 || is_show_tag">
                          <Dropdown
                              class="cancel"
                              placement="bottom-start"
                              @on-click="deleteConfirm(group_subscribe[subscribe_tag.findIndex((a) => a == item.id)].id)"
                              v-if="subscribe_tag.findIndex((a) => a == item.id) > -1">
                              <span>
                                  <i class="iconfont active">&#xe64b;</i>
                                  <i class="tag-name">{{item.name}}</i>
                              </span>
                              <DropdownMenu slot="list">
                                  <DropdownItem>取消关注</DropdownItem>
                              </DropdownMenu>
                          </Dropdown>
                          <span v-else @click="fieldChecked(item.id)" class="defalut">
                              <i class="iconfont">&#xe64a;</i>
                              <i class="tag-name">{{item.name}}</i>
                          </span>
                      </div>
                  </div>
              </div>
          </div> -->
          <div class="smt-btn">
              <div class="sure-button" @click="saveUserInfo">保存</div>
              <div class="cancel-button" @click='base_edit = false'>取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { attention_mixins } from 'js/attention_mixins'
import { updateUserInfo,getMeta,addSubscribe,deleteSubscribe,updateUserIdentity } from '../../service'
import { getAddPuv } from 'js/addPuv.js'
import Cookies from 'js-cookie'
export default {
  mixins: [attention_mixins, getAddPuv],
  data() {
    return {
      height: 0,
      tag_loading: false,
      clear_loading: false,
      base_edit: false, // 是否正在编辑基本信息
      form_data: {
        user_key: this.$store.state.user_key,
        name: '',
        comp_name: '',
        title: '',
        email: '',
      },
      identity_params: {
        user_key: this.$store.state.user_key,
        xuser_type_id: ''
      },
      rules: {
        name: [{required: true, message: '请填写您的姓名', trigger:'blur'} ],
        comp_name: [{required: true, message: '请填写您的公司名称', trigger:'blur' }],
        title: [{required: true, message: '请填写您的职位', trigger:'blur'} ],
        email: [{type: 'email', message: '邮箱格式不正确', trigger:'blur'} ],
      },
      xuser_type: [],
      recommend_tag_map: [],
      entity_ntag: [],
      form_smt_1: false,
      form_smt_2: false,
      is_show_tag: false
    }
  },
  computed: {
    group_subscribe() {
      const g_subscribe = []
      this.attention.subscribe.map((b) => {
        if(b.sub_type == '2'){
          g_subscribe.push({
            create_time: b.create_time,
            id: b.id,
            sub_type: b.sub_type,
            sub_type_id: b.sub_type_id,
          })
        }
      })
      return g_subscribe
    },
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      if (this.$store.state.user && typeof this.$store.state.user == 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    form_smt() {
      return this.form_smt_1 && this.form_smt_2
    }
  },
  methods: {
    /**
    * 按需获取元数据
    */
    async getMeta(cb) {
      let res = await getMeta({
        name: ['xuser_type', 'recommend_tag_map', 'entity_ntag']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'xuser_type', res.meta.xuser_type)
        this.$set(this.$data, 'recommend_tag_map', res.meta.recommend_tag_map)
        this.$set(this.$data, 'entity_ntag', res.meta.entity_ntag)
        if(cb) cb()
      } else {
        this.$Message.error(res.message)
      }
    },
    goEdit() {
      this.base_edit = true
      this.form_smt_1 = false
      this.form_smt_2 = false
      this.is_show_tag = false
      this.form_data.name = this.user.name
      this.form_data.comp_name = this.user.compName
      this.form_data.title = this.user.title
      this.form_data.email = this.user.email
      this.identity_params.xuser_type_id = this.user.xuser_type_id
    },
    saveUserInfo() { // 保存信息修改
      this.$refs['base_form'].validate(async (valid) => {
        if (valid) {
          if(this.identity_params.xuser_type_id) {
            this.updateUserIdentity()
          }else {
            this.form_smt_2 = true
          }
          let res = await updateUserInfo(this.form_data, (error) => { this.$Message.error('信息修改失败!') })
          if(res.status == 'success') {
            this.user.name = this.form_data.name
            this.user.title = this.form_data.title
            this.user.compName = this.form_data.comp_name
            this.user.email = this.form_data.email
            this.form_smt_1 = true
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    async updateUserIdentity() {
      let res = await updateUserIdentity(this.identity_params, (error) => { this.$Message.error('修改身份失败!') })
      if(res.status == 'success') {
        this.user.xuser_type_id = this.identity_params.xuser_type_id
        this.form_smt_2 = true
      } else {
        this.$Message.error(res.message)
      }
    },
    async fieldChecked (val) {
      const _that = this
      if(!this.tag_loading){
        this.tag_loading = true
        const add_tag = {
          sub_type: '2',
          sub_type_id: val,
          group_id: [this.selGroupId],
          user_key: this.user_key
        }
        let res = await addSubscribe(add_tag, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          this.getSubscribeList(function() {
            _that.$Message.success('关注成功！');
            _that.tag_loading = false;
          })
        } else {
          console.log(res)
        }
      }else{
        this.$Message.loading("添加中，请勿重复操作！")
      }
    },
    deleteConfirm(val) {
      const _that = this
      layer.confirm('确定不再关注？<br />取消关注，其他分组同步取消哦~', {
        title: false,
        offset: '100px',
        skin: 'layer-custom',
        btn: ['确定','取消'] //按钮
      }, function(){
        _that.clearAttention(val)
        layer.closeAll()
      }, function(){
        layer.closeAll()
      })
    },
    async clearAttention(val) {
      if(!this.clear_loading) {
        this.clear_loading = true
        const del_group = {
          op_type: 'cancel',
          subscribe_id: val,
          user_key: this.user_key
        }
        let res = await deleteSubscribe(del_group, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          const _that = this
          this.getSubscribeList(function() {
            _that.$Message.success('取消成功！');
            _that.clear_loading = false;
          })
        } else {
          this.$Message.error(res.message)
        }
      }else{
        this.$Message.loading("删除中，请勿重复操作！")
      }
    },
    goOpenVip() { // 去开通VIP
      this.$router.push({name: 'BuyVip'})
    }
  },
  created() {
    this.getMeta()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 107
    // window.onresize =  () => {
    //   this.height = document.documentElement.clientHeight - 147
    // }
    let url = window.location.href
    this.getAddPuv(url)
  },
  watch: {
    form_smt(val) {
      if(val) {
        // localStorage.user = JSON.stringify(this.user)
        // Cookies.set('user', this.user)
        this.$store.commit('updateUser', this.user)
        this.$Message.success('修改成功！')
        this.base_edit = false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
button()
  width:96px;
  height:32px;
  line-height: 32px;
  text-align: center;
  border-radius:4px;
  font-size: 14px;
  cursor: pointer;
.account-container
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  .left
    width: 210px;
    commonBgColor(#1F2330, #ffffff);
    display: inline-table;
    // border: 1px solid;
    commonBorderColor(none, #F0F0F0)
    .left-base
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 20px;
      img
        width: 80px;
        height: 80px;
        margin-top: 20px;
        border-radius: 50%;
      .default
        font-size: 80px;
        margin-top: 20px;
        commonColor(#ffffff, #666666)
      .nick-name
        margin-top: 12px;
        commonColor(#e9e9e9, #666666);
        font-size: 14px;
      .open-vip
        margin-top: 12px;
        font-size: 14px;
        line-height: 16px;
        color: #D8B06C;
        cursor: pointer;
        .vip-icon
          display: inline-block
          vertical-align: top
          width: 16px
          height: 16px
          margin-right: 4px
          margin-top: 0
          border-radius: 0
      .pop
        >>>.ivu-poptip-body
          padding: 20px;
          p
            color: #666666;
            font-size: 12px;
            text-align: center;
          .xufei
            margin: 15px auto 0;
            width: 74px;
            height: 22px;
            background: #D8B06C;
            border-radius:11px;
            line-height: 22px;
            text-align: center;
            color: #FFFFFF;
            font-size: 12px;
            cursor: pointer;
    .left-item
      height: 50px;
      commonColor(#E9E9E9, #333333);
      padding: 0 20px;
      line-height: 50px;
      commonBgColor(#2A2F42, #FFFAF5);
      cursor: pointer;
  .right
    flex: 1;
    margin-left: 16px;
    commonBgColor(#1F2330, #ffffff)
    .right-setting
      padding: 30px;
      > p
        padding-bottom: 15px;
        border-bottom: 1px solid;
        commonBorderColor(#40444F, #E9E9E9)
        commonColor(#E9E9EB, #333333)
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 10px;
      .tip
        line-height:20px
        font-size:14px
        font-weight:400
        commonColor(#E9E9EB, #666666)
        commonBgColor(#113056, #F2FAFF)
        border-radius:4px
        padding: 12px 20px
        i
          font-size: 20px
          vertical-align: top
          display: inline-block
          margin-right: 12px
          commonColor(#FC9C7C, rgba(250, 122, 80, 1))
      .show-div
        padding-left: 40px
        padding-top: 30px
        p
          commonColor(#e9e9e9, #666666);
          font-size: 14px;
          span
            &:first-of-type
              position: relative
              commonColor(#8F9198, #666666)
              &.must:before
                content: '*'
                position: absolute
                font-size: 14px
                color: #ED4014
                top: 4px
                left: -10px
            &+span
              margin-left: 16px;
          &+p
            margin-top: 20px;
        .d-tag
          display: flex
          margin-left: -28px
          margin-top: 20px
          > p
            flex: 0
            white-space: nowrap
            commonColor(#8F9198, #666666)
            line-height: 32px
          > div
            flex: auto
            margin-left: 16px
            margin-bottom: -10px
            span
              commonBgColor(#35383F, #F9F9F9)
              commonColor(#BCBDC1, #666666)
              margin: 0 10px 10px 0
              inlineBlock()
              padding: 10px 12px
        .edit-button
          background: rgba(250, 122, 80, 1);
          color: #FFFFFF;
          margin-left: 46px;
          margin-top: 30px;
          button()
      .editing-div
        padding-left: 40px
        padding-top: 30px
        .ivu-form-item
          margin-bottom: 20px
        >>> .ivu-form-item-label
          commonColor(#8F9198, #999999);
          font-size: 14px
          position: relative
          padding: 11px 0
        >>> .phone
        >>> .ivu-form-item-required
          .ivu-form-item-label:before
            content: '*'
            position: absolute
            font-size: 14px
            color: #ED4014
            top: 11px
            left: -10px
        // >>> .ivu-form-item-content
        //   font-size: 0
        >>> .ivu-input-wrapper
          width: 360px;
          input
            background: transparent
            commonBorderColor(#7A7F94, #CCCCCC);
            border: 1px solid #D5d5d5;
            commonColor(#e9e9e9, #333333);
            height: 36px
            font-size: 14px
            line-height: 18px
            padding: 8px 12px
            &::placeholder
              commonColor(#8f9198, #aaaaaa)
        .smt-btn
          margin-left: 50px
          margin-top: 20px
        .sure-button
          background: rgba(250, 122, 80, 1);
          color: #FFFFFF;
          display: inline-block;
          button()
        .cancel-button
          commonBgColor(#1F2330, #ffffff);
          color: rgba(250, 122, 80, 1);
          border:1px solid rgba(250, 122, 80, 1);
          display: inline-block;
          margin-left: 20px;
          button()
        .more-title
          margin-left: -40px
          font-size:14px
          font-weight:600
          commonColor(#e9e9e9, #333333)
          position: relative
          &:before
            content: ''
            position: absolute
            width: 825px
            height: 0
            border-bottom: 1px dashed
            commonBorderColor(#40444F, #E9E9E9)
            right: 0
            top: 6px
        .identity
        .tag
          margin-left: -40px
          display: flex
          margin-top: 20px
          > p
            font-size: 14px
            position: relative
            line-height: 36px
            flex: 0 0 90px
            padding-left: 14px
            commonColor(#8F9198, #999999)
          > div
            flex: auto
            .tags-list
              padding-top: 2px
              padding-right: 42px
              margin-bottom: -20px
              position: relative
              a.show-all
                position: absolute
                bottom: 30px
                right: 0
                cursor: pointer
                .iconfont
                  font-size: 12px
                  margin-left: 6px
                  inlineBlock()
              .span_tag
                commonBgColor(#35383F, #F9F9F9)
                margin: 0 10px 20px 0
                padding: 0
                span
                  inlineBlock()
                  cursor: pointer
                  padding: 10px 12px
                &:hover
                  .defalut
                    i.iconfont
                    i.tag-name
                      color: rgba(250, 122, 80, 1) !important
                i.iconfont
                  margin-right: 8px
                  inlineBlock()
                  commonColor(#BCBDC1, #AAAAAA)
                  font-size: 12px
                  &.active
                    color: #49B580 !important
                i.tag-name
                  commonColor(#E9E9EB, #333333)
                  font-size: 12px
                  font-style: normal
                  inlineBlock()
              .cancel
                & >>> .ivu-select-dropdown
                  border-radius: 0
                  padding: 0
                  commonBgColor(#2D2F34, #FFFFFF)
                  commonShadow(0 4px 20px 0 rgba(0,0,0,.5),2px 4px 20px 0 rgba(121,133,143,.2))
                  .ivu-dropdown-item
                    line-height: 1
                    padding: 12px 16px
                    commonColor(rgba(255,255,255,.9), #333333)
                    &:hover
                      commonColor(rgba(255,255,255,.9), rgba(250, 122, 80, 1))
                      commonBgColor(#35383F, #FFFFFF)
            .identity-sel
              width: 360px
              >>> .ivu-select-selection
                background-color: transparent
                commonBorderColor(#7A7F94, #CCCCCC)
                height: 36px
                commonColor(#e9e9e9, #333333)
                font-size: 14px
                .ivu-select-placeholder
                .ivu-select-selected-value
                  commonColor(#e9e9e9, #333333)
                  padding: 0 12px
                  height: 36px
                  line-height: 36px
                  font-size: 14px
                .ivu-select-placeholder
                  commonColor(#8f9198, #aaaaaa)
              >>> .ivu-select-dropdown
                commonBgColor(#1F2330, #ffffff)
                commonShadow(0 -4px 20px 0 rgba(0,0,0,.5), 0px -4px 20px 0px rgba(121,133,143,.1))
                .ivu-select-dropdown-list
                  .ivu-select-item
                    commonColor(#e9e9eb, #666666)
                    &:hover
                      commonColor(inhert, rgba(250, 122, 80, 1))
                      commonBgColor(#353945, #ffffff) !important
                    &.ivu-select-item-selected
                      color: rgba(250, 122, 80, 1)
                    &.ivu-select-item-selected:hover
                      color: rgba(250, 122, 80, 1)
                    &.ivu-select-item-focus
                      // background: #1f2330
                      commonBgColor(#1f2330, #ffffff)
</style>
